import { MDBDropdownToggle } from 'mdb-react-ui-kit';
import styled from 'styled-components';

export const DropdownToggle = styled(MDBDropdownToggle)`
    cursor: pointer;
    padding-top: 0.2rem;
    &::after {
        display: none !important;
    }
`;
